<template>
  <standard-dialog
    v-model="model"
    :title="isEditing ? $t('edit_driver') : $t('add_driver')"
    icon="mdi-account-hard-hat"
    :save-text="$t('save')"
    :loading="saving"
    @save="save"
  >
    <v-form ref="form" v-model="valid">
      <v-row>
        <!-- Name -->
        <v-col cols="12" sm="6">
          <text-field
            v-model="form.name"
            :label="$t('name')"
            :rules="[rules.required]"
          />
        </v-col>

        <!-- Last name -->
        <v-col cols="12" sm="6">
          <text-field
            v-model="form.lastname"
            :label="$t('last_name')"
            :rules="[rules.required]"
          />
        </v-col>

        <!-- Phone -->
        <v-col cols="12" sm="6">
          <text-field
            v-model="form.phone"
            :label="$t('phone_no')"
            kind="phone"
            :rules="[rules.required]"
          />
        </v-col>

        <!-- Email -->
        <v-col cols="12" sm="6">
          <text-field
            v-model="form.email"
            :label="$t('email')"
            type="email"
            :rules="[rules.email]"
          />
        </v-col>

        <!-- Vehicle type(s) -->
        <v-col cols="12" sm="6">
          <dropdown
            v-model="form.vehicle_types"
            :items="vehicleOptions"
            item-text="text"
            item-value="value"
            :label="$t('vehicle_type')"
            :rules="[vehicleTypesRequired]"
            multiple
            required
          />
        </v-col>

        <!-- Active -->
        <v-col cols="12" sm="6">
          <v-switch
            v-model="form.active"
            :label="$t('active')"
            inset
            dense
            hide-details
            class="mt-6"
          />
        </v-col>

        <!-- Note -->
        <v-col cols="12">
          <text-area v-model="form.note" :label="$t('note')" rows="2" />
        </v-col>
      </v-row>
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import { VEHICLE_TYPES } from "@/data/supplierDrivers";

const emptyForm = () => ({
  name: "",
  lastname: "",
  phone: "",
  email: "",
  vehicle_types: ["bicycle"],
  active: true,
  note: "",
});

export default {
  name: "SupplierDriverDialog",
  components: { StandardDialog },
  mixins: [hasModel, hasValidation],

  props: {
    editedDriver: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      valid: false,
      saving: false,
      form: emptyForm(),
    };
  },

  computed: {
    isEditing() {
      return !!(this.editedDriver && this.editedDriver.id);
    },
    vehicleOptions() {
      return VEHICLE_TYPES.map((v) => ({
        value: v.value,
        text: this.$t(v.labelKey),
        icon: v.icon,
      }));
    },
  },

  watch: {
    model(val) {
      if (val) {
        this.form = this.editedDriver
          ? { ...emptyForm(), ...this.editedDriver }
          : emptyForm();
        this.$nextTick(() => this.$refs.form?.resetValidation());
      }
    },
  },

  methods: {
    vehicleTypesRequired(value) {
      return (Array.isArray(value) && value.length > 0) || this.$t("validation.required");
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      const payload = { ...this.form, id: this.isEditing ? this.editedDriver.id : null };
      // No backend endpoint exists yet for supplier drivers. We simulate a short
      // delay so the loader/save flow feels consistent with the rest of the app,
      // then let the parent page know the demo-data save has "completed".
      setTimeout(() => {
        this.saving = false;
        this.$emit("saved", payload);
        this.$emit("input", false);
      }, 400);
    },
  },
};
</script>
